import { SearchComponentOfType } from "@utils/search/@types/searchComponent";

import { DeviceType } from "@services/breakpoint.service";

export type ResultListRequest = {
    component: SearchComponentOfType<"RESULT_LIST">;
};
export type HitsPerPageRequest = {
    component: SearchComponentOfType<"HITS_PER_PAGE">;
    hitsPerPage: number;
};
export type PaginationRequest = {
    component: SearchComponentOfType<"PAGINATION">;
    hitsWithInjected: number;
    hitsWithoutInjected: number;
    hitsRequested?: number,
};
export type NumberOfHitsRequest = {
    component: SearchComponentOfType<"NUMBER_OF_HITS">;
};
export type FacetsRequest = {
    component: SearchComponentOfType<"FACETS">;
};
export type SortRequest = {
    component: SearchComponentOfType<"SORT">;
    sortBy: string;
};

export type ComponentSearchRequest =
    | ResultListRequest
    | HitsPerPageRequest
    | PaginationRequest
    | NumberOfHitsRequest
    | FacetsRequest
    | SortRequest;

export type ComponentSearchRequests = Array<ComponentSearchRequest>;

export type DynamicFacetsSearchParams = {
    amount?: number;
    cutoff?: number;
};

export type SearchParams = {
    dynamicFacets?: DynamicFacetsSearchParams;
};

export enum SearchContextEntryType {
    DEVICE = "DEVICE",
}

export type SearchContext = {
    [SearchContextEntryType.DEVICE]: DeviceType;
};

export type SearchRequest = {
    query?: string;
    debug?: boolean;
    params?: SearchParams;
    filters?: string;
    userToken?: string;
    clickAnalytics?: boolean;
    context: SearchContext;
    components: ComponentSearchRequests;
};
